;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.PreRegistration = Backbone.Model.extend({

		isNew: function(){
			return true;
		},
		
		preregistration: function(data) {
			this.setApiUrl('preregistration');
			this.save({}, {
				data: data,
				success: _.bind(function(model, resp) {
					if (resp.errors.length) {
						this.trigger('preregistration:errors', resp.errors);
					}
					else {
						this.trigger('preregistration:success');
					}
				}, this)
			});
		}

	});

}(window, APP, Backbone, Marionette, $, _));